module.exports = __webpack_public_path__ + "img/no-ava.d47e1d73.svg";